<mat-card class="mat-elevation-y0 outline">
  <mat-card-content>
<google-map 
  height="400px"
  width="50wv"
  [center]="center"
  [zoom]="zoom"
  [options]="options"
  (mapClick)="addMarker($event)">
    <map-marker-clusterer [imagePath]="markerClustererImagePath">
      @for (position of coordinates; track position) {
        <map-marker   #marker="mapMarker" [position]="position"      (mapClick)="openInfoWindow(marker, infoWindow)" />
        <map-info-window #infoWindow="mapInfoWindow">
          <div class="info-window" >
            <div class="info-window-content" style="width: 300px;">
              <h4 style="text-align:center;margin:0" class="title-info-element"><strong> {{ position.uuid }}</strong></h4>
              <div><mat-icon  class="mat-mdc-tooltip-trigger material-symbols-outlined" style="position: relative; top:7px">explore_nearby</mat-icon> {{ position.comune }}</div>
              <div><mat-icon  class="mat-mdc-tooltip-trigger material-symbols-outlined" style="position: relative; top:7px">valve</mat-icon> {{ position.tipoPuntoCampionamento }}</div>
<!--               <div><strong>Latitudine:</strong> {{ position.lat }}</div>
              <div><strong>Longitudine:</strong> {{ position.lng }}</div> -->
              <div> <a  style="color:#000; text-decoration: none; cursor:pointer" (click)="navigateToDetail(position.uuid)"><mat-icon  class="mat-mdc-tooltip-trigger material-symbols-outlined" style="position: relative; top:7px">link</mat-icon> Vai al dettaglio</a></div>
              <div></div>
            </div>
          </div>
        </map-info-window>
      }
    </map-marker-clusterer>
</google-map>
</mat-card-content>
</mat-card>